import Web3 from 'web3'
import React from 'react'
import { notification } from 'antd'
import { cloneDeep } from 'lodash'

import Icon from '_src/components/Icon'

import { multiply } from './math'

export function isDev() {
  return process.env.REACT_APP_ENV === 'DEV' || process.env.REACT_APP_ENV === 'TEST'
}

export function tranChainId(chain_id) {
  const id = Web3.utils.isHexStrict(chain_id || 0) ? Web3.utils.hexToNumber(chain_id) : chain_id

  return id
}

/**
 * @description: 裁剪字符串
 * @param {String} string   原字符串
 * @param {Number} number  从那个位置开始进行裁剪
 * @param {String} fill  填充
 * @return {String | void}
 */
export function sliceFillText(string, number = 5, fill = '...') {
  if (string) {
    if (Array.from(string).length > number) {
      return `${string.slice(0, multiply(-1, number))}${fill}`
    }
    return string
  }
  return ''
}

/**
 * @description: 数字不使用科学计数法
 * @param {String} num   原字符串
 * @return {String}
 */
export function toNonExponential(num) {
  const m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/)
  return num.toFixed(Math.max(0, (m[1] || '').length - m[2]))
}

/**
 * @description: 数字不使用科学计数法
 * @param {Number} sell_price   原字符串
 * @param {Number} number  位数
 * @return {String}
 */
export function slicePrice(sell_price, number = 6) {
  let price = sell_price
  if (sell_price.toString().length > number) {
    const string = price.toString().slice(0, number)

    if (string.padEnd('.')) {
      price = `${string}..`
    } else {
      price = `${string}...`
    }
  }

  return price
}

/**
 * @description: 通知信息
 * @param {String} title
 * @param {String} icon  icon-status-error  icon-status-success  icon-status-warning
 * @param {Number} duration  秒
 * @return {Null}
 */
export const createNotification = (title, icon = 'icon-status-success', duration = 5) => {
  const message = (
    <div className="cust-notification-content">
      <Icon type={icon} className="notification-icon" />
      <div className="notification-title">{title}</div>
    </div>
  )

  notification.open({
    className: 'cust-notification',
    closeIcon: <Icon type="icon-notification-close" style={{ fontSize: 18, opacity: 0.8 }} />,
    duration,
    message,
    description: '',
    top: 140,
  })
}

/**
 * @description: 扁平化数组
 * @param {Array} array
 * @return {Array}
 */
export const flattenArray = (array) => {
  return array.reduce((result, item) => {
    if (Object.prototype.hasOwnProperty.call(item, 'children') && Array.isArray(item.children)) {
      return result.concat([item]).concat(flattenArray(item.children))
    }
    return result.concat([item])
  }, [])
}

/**
 * @description: 找到节点的所有父节点
 * @param {Array} array
 * @param {String} url
 * @return {Array}
 */
export const findArrayParents = (array, func, path = []) => {
  if (!array) return []
  for (const data of array) {
    path.push(data.path)
    if (func(data)) return path
    if (data.children) {
      const findChildren = findArrayParents(data.children, func, path)
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
}

/**
 * @description: 判断文件类型
 * @param {String} type
 */
export const fileType = (type) => {
  type = type?.toUpperCase()
  let imageUrl = ['JPG', 'JPEG', 'PNG', 'GIF', 'SVG']
  let audioUrl = ['WAV', 'MP3', 'OGG']
  let videoUrl = ['MP4', 'WEBM']
  if (imageUrl.includes(type)) {
    return 1
  } else if (audioUrl.includes(type)) {
    return 2
  } else if (videoUrl.includes(type)) {
    return 3
  }
}

/**
 * @description: 获取url问号后的参数
 * @param {String} type
 */
export const obtainUrlParameter = (parameter) => {
  let str = parameter.split(/[?&#]/)
  let obj = {}
  if (parameter) {
    for (let i = 0; i < str.length; i++) {
      if (str[i].indexOf('=') != -1) {
        let arr = str[i].split('=')
        obj[arr[0]] = decodeURIComponent(arr[1])
      }
    }
  }
  return obj
}

/**
 * @description: 获取url问号后的参数
 * @param {String} type
 */
export const deleteUrlParameter = (parameter, type) => {
  let str = parameter.replace(/&/g, '@&').split(/[?@#]/)
  let obj = ''
  if (parameter) {
    for (let i = 0; i < str.length; i++) {
      if (str[i].indexOf(type) === -1) {
        obj += str[i]
      }
    }
  }
  return obj
}

export const copyDeep = (value) => {
  return cloneDeep(value)
}
